import { render } from "./TemporaryWarehouseTable.vue?vue&type=template&id=84fc2b5a&scoped=true"
import script from "./TemporaryWarehouseTable.vue?vue&type=script&lang=js"
export * from "./TemporaryWarehouseTable.vue?vue&type=script&lang=js"

import "./TemporaryWarehouseTable.vue?vue&type=style&index=0&id=84fc2b5a&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84fc2b5a"]])

export default __exports__